import {Select} from 'antd';
import PropTypes from 'prop-types';
import React, {memo, useMemo} from 'react';
import {useTranslation} from 'react-i18next';

const DynamicFieldSelect = ({value, onChange, options, mapOptions, translate = 'common', ...props}) => {
  const {t} = useTranslation(translate);
  
  const optionsMapped = useMemo(() => {
    if (typeof mapOptions === 'function') {
      return mapOptions(options, t);
    }
    return options;
  }, [mapOptions, options, t]);
  
  return (<Select value={value} options={optionsMapped} onChange={onChange} {...props} />);
};

DynamicFieldSelect.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  mapOptions: PropTypes.func,
  translate: PropTypes.string,
  options: PropTypes.array,
};

export default memo(DynamicFieldSelect);
